<template>
	<Modal
    v-if="src"
		ref="modal"
    :overlay-type="modalName"
		:html-classes="['hide--header', 'show--modal']"
		:initial-visible="initialVisible"
		light
		full-height
	>
		<iframe
      v-if="src"
      class="overlay-dialog__iframe"
      :src="src"
      frameborder="0"
    />
	</Modal>
</template>

<script>
import Modal from '@/components/Modal';

const IFRAME_BLANK = 'javascript:void(0)'

export default {
	components: {
		Modal,
	},
  props: {
	},
	data() {
		return {
      src: this.$root.options.src ?? IFRAME_BLANK,
			modalName: this.$root.options.modalName || 'content-overlay',
			initialVisible: !!this.$root.options.initialVisible,
		};
	},
}
</script>

<style>

</style>
